import Unexpected from "../../../Exception/Unexpected.class"
import { DIRECTION_DXDY_EAST, DIRECTION_DXDY_NORTH, DIRECTION_DXDY_SOUTH, DIRECTION_DXDY_WEST } from "../../direction/dijkstraDirections"
import { type DirectionDxDy } from "../../direction/DirectionDxDy.type"
import { EntityHeadingDeg } from "./consts"
import type { EntityHeading } from "./EntityHeading.type"

export function directionDxDyToEntityHeading(dir: DirectionDxDy): EntityHeading {
  if (dir === DIRECTION_DXDY_SOUTH) return EntityHeadingDeg.North
  if (dir === DIRECTION_DXDY_EAST) return EntityHeadingDeg.East
  if (dir === DIRECTION_DXDY_NORTH) return EntityHeadingDeg.South
  if (dir === DIRECTION_DXDY_WEST) return EntityHeadingDeg.West

  throw new Unexpected('!(dir in dijkstraDirections)')
}